<template>
  <div class="page-about">
    <Header  path='/about'></Header>

    <div class="about-banner"></div>
    <div class="about-company">
      <h3>公司简介</h3>
      <p>重庆神缘智能科技有限公司是一家专业从事物联网燃气表及智能燃气管理平台研发、生产的高新技术企业。公司拥有一支专业研发和具备多年燃气行业管理经验的团队，深耕物联网燃气表、智能燃气管理平台相关核心技术研究。公司以客户为中心，以激情铸就辉煌为宗旨，以热情、诚信服务为理念，致力于物联网技术的研发，积极探索智慧燃气领域创新发展，着力打造 “渝神缘” 品牌。</p>
    </div>
    <div class="company-spirit">
      <img src="@/assets/about/about_page_03.jpg" alt="">
    </div>
    <div class="about-dev-history">
      <div class="history-head"></div>
      <div class="history-body-wrap ui-flex ui-flex-justify-center">
        <div class="history-body ele-wrap  ui-flex">
          <swiper ref="mySwiper" :options="swiperOptions" >
            <swiper-slide v-for="(value) in columns" :key="value.id">
              <div class="body-column" >
                <div class="column-title">{{value.title}}</div>

                <ul class="column-list">
                  <li class="list-li" v-for="(v) in value.children" :key="v.id">
                    <strong class="list-li-month">{{v.month}}</strong>
                    <span class="list-li-explain">{{v.explain}}</span>
                  </li>
                </ul>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>

        </div>

      </div>
    </div>

    <Footer></Footer>

  </div>

</template>
<script>
   import Header from '@/components/Header/index.vue'
  import Footer from '@/components/Footer/index.vue'
  import router from '@/router'
  import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    components: {
      Swiper,
      SwiperSlide,
      Header,
      Footer,
    },
    directives: {
      swiper: directive
    },
    data() {
      return {
        swiperOptions: {
          autoplay:false,
          autoplayStopOnLast:false,
          slidesPerView: 3,
          slidesPerGroup: 3,
          pagination: {
            el: '.swiper-pagination'
          },

        },
        columns:[
          {id:0,title:'2020',children:[
            {id:0,month:'1月',explain:'公司取得“ISO三体系管理认证证书”。'},
          ]},
          {id:1,title:'2019',children:[
            {id:0,month:'12月',explain:'“渝神缘”物联网膜式燃气表正式取得型式批准证书。'},
            {id:1,month:'11月',explain:'公司获得国家“高新技术企业”'},
            {id:2,month:'6月',explain:'“智能燃气管理平台2.0“正式上线'},
            {id:3,month:'5月',explain:'公司各产品均取得“防爆合格证”'},
            {id:4,month:'1月',explain:'“渝神缘”物联网膜式燃气表销量突破十万只'},
          ]},
          {id:2,title:'2018',children:[
            {id:0,month:'12月',explain:'公司取得“基于霍尔开关传感器的天然气表”专利技术(CN202130178838.0)'},
            {id:1,month:'1月',explain:'“渝神缘”物联网膜式燃气表销量突破3万只'},

          ]},
          {id:3,title:'2017',children:[
            {id:0,month:'12月',explain:'第一只物联网膜式燃气表研发成功'},
            {id:1,month:'1月',explain:'“智能燃气管理平台1.0”正式上线'},

          ]},
          {id:4,title:'2016',children:[
            {id:0,month:'7月',explain:'“重庆神缘智能科技有限公司”正式成立。'},

          ]},

        ]
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>